import pubsub from 'sweet-pubsub';
export const useCti = (functions) => {
    const { onLogin, onNumberSelected, onCallInitiated, onCallStarted, onCallEnded, onLogout } = functions || {};
    let phoneNumber = null;
    pubsub.on('login', ({ mobile, email, first_name, last_name }) => {
        if (phoneNumber) {
            pubsub.emit('initiate_call', phoneNumber);
        }
        if (onLogin && typeof onLogin === "string") {
            eval(`(${decodeURI(onLogin)})(${JSON.stringify({ mobile, email, first_name, last_name })})`);
        }
    });
    pubsub.on('number_selected', (number) => {
        if (onNumberSelected && typeof onNumberSelected === "string") {
            eval(`(${decodeURI(onNumberSelected)})(${number})`);
        }
    });
    pubsub.on('call_started', ({ direction, peer }) => {
        const timeStamp = Date.now();
        const payload = {
            timeStamp,
            direction,
            mobile: peer,
            duration: 0,
            notes: ""
        };
        if (phoneNumber) {
            payload.mobile = phoneNumber;
        }
        if (onCallStarted && typeof onCallStarted === "string") {
            // onCallStarted(payload)
            eval(`(${decodeURI(onCallStarted)})(${JSON.stringify(payload)})`);
        }
    });
    pubsub.on('call_ended', ({ direction, peer, duration, notes }) => {
        if (onCallEnded && typeof onCallEnded === "string") {
            const timeStamp = Date.now();
            const payload = {
                timeStamp,
                direction,
                mobile: peer,
                duration,
                notes
            };
            // onCallEnded({direction, peer, duration, notes})
            eval(`(${decodeURI(onCallEnded)})(${JSON.stringify(payload)})`);
        }
    });
    pubsub.on('logout', () => {
        if (onLogout && typeof onLogout === "string") {
            // onLogout()
            eval(`(${decodeURI(onLogout)})()`);
        }
    });
    pubsub.on('initiate_call', (phone) => {
        if (onCallInitiated && typeof onCallInitiated === "string") {
            eval(`(${decodeURI(onCallInitiated)})(${phone})`);
        }
    });
    console.log(">>>>>>>> Pressone events initialized >>>>>>>>>");
    return null;
};
